<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title
                >{{ $route.params.tagId === "new" ? "Add new" : activeTag.name | t }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <general-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <clients-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import GeneralEditTab from "./tag-tab-items/general-edit-tab";
import ClientsEditTab from "./tag-tab-items/clients-edit-tab";

export default {
    name: "tag-edit",
    components: { GeneralEditTab, ClientsEditTab },

    data() {
        return {
            tab: 0,
            tabs: ["General", "Clients"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.tagId === "new") {
            await this.addNewTag();
        } else {
            await this.getTagData(this.$route.params.tagId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("TagStore", ["activeTag", "errorMessage", "requestSuccess"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true) {
                this.$router.push({
                    name: "tag-list"
                });
            }
        }
    },
    methods: {
        ...mapMutations("TagStore", ["addNewTag"]),
        ...mapActions("TagStore", ["submitTagUpdate", "getTagData"]),
        closeDrawer() {
            this.$router.push({ name: "tag-list" });
        },
        async submitEdit() {
            await this.submitTagUpdate(this.activeTag);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused")
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
